import useApi from "..";

const useChatApi = () => {
    const { request } = useApi(); 
  
    // chatId == channelId
    const getChatChannels = () => request(`/chat/channel`, 'GET', null);
    const getChatMessagesByChannelId = (chatId, limit, offset) => request(`/chat/channel/${chatId}?limit=${limit}&offset=${offset}`, 'GET', null);
    const getMsgOrNotificationReadStatus = () => request(`/chat/notification`, 'GET', null);
    const createChatChannel = (payload) => request(`/chat/channel`, 'POST', payload);
    const acceptChatInvite = (chatId) => request(`/chat/accept-request/${chatId}`, 'PATCH', null);
    const blockUser = (payload) => request(`/user/block-unblock`, 'POST', payload);
    
    return { 
        getChatChannels,
        createChatChannel,
        getChatMessagesByChannelId,
        getMsgOrNotificationReadStatus,
        acceptChatInvite,
        blockUser
    };
};

export default useChatApi;
